import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authService } from '../api/axios';
import './AuthForm.css';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!token) {
            setError('Missing reset token. Please request a new password reset link.');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        if (newPassword.length < 8) {
            setError('Password must be at least 8 characters long.');
            return;
        }

        setLoading(true);
        try {
            const response = await authService.post('/auth/reset-password', {
                token: token,
                newPassword: newPassword
            });
            setMessage(response.data);
            setTimeout(() => {
                navigate('/login');
            }, 3000); // Redirect to login after 3 seconds
        } catch (err) {
            setError(err.response?.data || 'Failed to reset password. The link might be expired.');
        } finally {
            setLoading(false);
        }
    };

    return (
        // Added flex layout here to center the content
        <div className="auth-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '20px' }}>

            {/* Added flex: 'none' and styling to match ForgotPassword */}
            <div className="auth-form-panel" style={{ width: '100%', maxWidth: '450px', flex: 'none', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>

                <div className="auth-form-container">
                    <h2>Reset Password</h2>
                    <p className="form-subtitle">Enter your new password below.</p>

                    {message && <p className="success-message" style={{ color: 'green', marginBottom: '15px' }}>{message}</p>}
                    {error && <p className="error-message">{error}</p>}

                    {!message && (
                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <input
                                    type="password"
                                    className="auth-input"
                                    placeholder="New Password (min 8 characters)"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="input-group">
                                <input
                                    type="password"
                                    className="auth-input"
                                    placeholder="Confirm New Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit" className="auth-button-primary" disabled={loading} style={{ marginTop: '10px' }}>
                                {loading ? 'Resetting...' : 'Reset Password'}
                            </button>
                        </form>
                    )}
                    <div className="form-links" style={{ marginTop: '20px', textAlign: 'center' }}>
                        <Link to="/login" className="auth-link">Return to Login</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;